module.exports = __webpack_public_path__ + "img/arh_14.9305a595.jpg";